import styled from 'styled-components';
import { desktop_breakpoint_extended } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const BasicTextStyles = styled.div`
  box-sizing: border-box;
  margin: 15px 15px;
  max-width: 400px;
  padding-bottom: 20px;

  .info-card {
    border-bottom: 1px solid ${Colors.accent.grey5.standard};
    margin: 30px 0;
    padding-bottom: 5%;

    &:last-child {
      border: none;
    }
  }
  p {
    a {
      /* cursor: pointer; */
      text-decoration: none;
      font-family: 'source-sans-pro', sans-serif;

      &.tel {
        /* cursor: pointer; */
        font-size: 14px;
      }
    }
  }

  @media only screen and (min-width: 500px) {
    max-width: 480px;
  }
  @media only screen and (min-width: ${desktop_breakpoint_extended}px) {
    margin-left: 50px;
    margin-top: 0;
    max-width: 300px;
    width: calc(40% - 50px);

    .info-card:first-child {
      margin-top: 20px;

      h5 {
        margin-top: 0;
      }
    }
  }
`;

export default BasicTextStyles;
